<template>
  <div class="content-component">
    <div style="position:relative">
  <!-- <span class="select-per-page" style="display:inline-block; margin:2px;"> -->
    <!-- <vs-select @change="changeOption" width="65px" v-model="selectedDefault">
      <vs-select-item
        v-for="num in nums"
        :key="num"
        :value="num"
        :text="num"
      ></vs-select-item>
    </vs-select> -->
    <el-select id="selPerPage" @change="changeOption" placeholder="" style="width: 75px; border-radius: 100px !important;padding-right: 5px;" v-model="selectedDefault">
      <el-option
        v-for="num in nums"
        :key="num"
        :label="num"
        :value="num">
      </el-option>
    </el-select>
  <!-- </span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "registers-per-page",
  props: {
    perPage: {
      default: 10
    }
  },
  data() {
    return {
      nums: [10, 20, 30, 50, 100],
      selectedDefault: this.perPage
    };
  },
  computed: {
    perPageValue: {
      get() {
        return this.perPageValue;
      },
      set(newVal) {
        this.selectedDefault = newVal;
      }
    }
  },
  // watch: {
  //   perPage(newVal) {
  //     this.selectedDefault = newVal;
  //   }
  // },
  mounted() {
    this.selectedDefault = this.perPage;
  },
  methods: {
    changeOption() {
      //console.log(this.selectedDefault)
      this.$emit("changeNumPerPage", this.selectedDefault);
    }
  }
};
</script>

<style>
.content-component {
  position: relative;
  display: inline-block;
}

.select-per-page {
  padding-right: 5px;
}

#selPerPage {
  width: 75px;
  border-radius: 100px !important;
}

.select-per-page .vs-select--input{
  border-radius: 100px;
}
</style>
